<div
  class="modal fade"
  id="exampleModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ 'change_password' | transloco }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        @if (form) {
          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="d-flex flex-column gap-3">
            @if (whoSignIn === UserTypeEnum.patient) {
              <app-input-phone-email formControlName="contact" />
            } @else {
              <div class="input-group">
                <span class="input-group-text">
                  <i class="bi bi-envelope"></i>
                </span>
                <div class="form-floating">
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    formControlName="email"
                    placeholder="{{ 'email' | transloco }}"
                    [class.is-invalid]="form.controls['email'].invalid && form.controls['email'].touched"
                  />
                  <label [appRequiredAsterisk]="'email'" [formGroup]="form" for="email">
                    {{ 'email' | transloco }}
                  </label>
                </div>
                @if (form.controls['email'].touched && form.controls['email'].hasError('required')) {
                  <div class="invalid-feedback">
                    {{ 'error.fill_field' | transloco }}
                  </div>
                } @else if (form.controls['email'].touched && form.controls['email'].hasError('email')) {
                  <div class="invalid-feedback">
                    {{ 'error.email' | transloco }}
                  </div>
                }
              </div>
            }

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <div class="form-floating">
                <input
                  [type]="passwordChecked ? 'text' : 'password'"
                  class="form-control"
                  id="passwordOld"
                  formControlName="passwordOld"
                  placeholder="{{ 'password_old' | transloco }}"
                  [class.is-invalid]="form.controls['passwordOld'].invalid && form.controls['passwordOld'].touched"
                />
                <label for="passwordOld" [appRequiredAsterisk]="'passwordOld'" [formGroup]="form">
                  {{ 'password_old' | transloco }}
                </label>
              </div>
              <span class="input-group-text">
                <label class="btn btn-outline-secondary" (click)="passwordChecked = !passwordChecked">
                  <i class="bi" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
                </label>
              </span>
              @if (form.controls['passwordOld'].touched && form.controls['passwordOld'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              }
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <div class="form-floating">
                <input
                  [type]="passwordChecked ? 'text' : 'password'"
                  class="form-control"
                  id="passwordNew"
                  formControlName="passwordNew"
                  placeholder="{{ 'password_new' | transloco }}"
                  [class.is-invalid]="form.controls['passwordNew'].invalid && form.controls['passwordNew'].touched"
                />
                <label for="passwordNew" [appRequiredAsterisk]="'passwordNew'" [formGroup]="form">
                  {{ 'password_new' | transloco }}
                </label>
              </div>
              <span class="input-group-text">
                <label class="btn btn-outline-secondary" (click)="passwordChecked = !passwordChecked">
                  <i class="bi" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
                </label>
              </span>
              @if (form.controls['passwordNew'].touched && form.controls['passwordNew'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              } @else if (form.controls['passwordNew'].hasError('passwordInvalid')) {
                <div class="invalid-feedback">
                  {{ 'error.password' | transloco }}
                </div>
              }
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="bi bi-lock"></i></span>
              <div class="form-floating">
                <input
                  [type]="passwordChecked ? 'text' : 'password'"
                  class="form-control"
                  id="repeatPassword"
                  formControlName="repeatPassword"
                  placeholder="{{ 'repeat_password' | transloco }}"
                  [class.is-invalid]="
                    form.controls['repeatPassword'].invalid && form.controls['repeatPassword'].touched
                  "
                />
                <label for="repeatPassword" [appRequiredAsterisk]="'repeatPassword'" [formGroup]="form">
                  {{ 'repeat_password' | transloco }}
                </label>
              </div>
              <span class="input-group-text">
                <label class="btn btn-outline-secondary" (click)="passwordChecked = !passwordChecked">
                  <i class="bi" [class]="passwordChecked ? 'bi-eye' : 'bi-eye-slash'"></i>
                </label>
              </span>
              @if (form.controls['repeatPassword'].touched && form.controls['repeatPassword'].hasError('required')) {
                <div class="invalid-feedback">
                  {{ 'error.fill_field' | transloco }}
                </div>
              } @else if (form.hasError('passwordMismatch')) {
                <div class="invalid-feedback d-block">
                  {{ 'error.password_repeat' | transloco }}
                </div>
              }
            </div>

            <button type="submit" class="btn btn-primary w-100 mt-3" [disabled]="!form.valid">
              {{ 'save' | transloco }}  
            </button>

            <div class="text-center mt-2 cursor">
              <a routerLink="/restore" (click)="closeDialogModal()" class="link-primary">
                {{ 'forgot_password' | transloco }}
              </a>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
